// extracted by mini-css-extract-plugin
module.exports = {"top":"itemView_docList_top___U4a4","wrapper":"itemView_docList_wrapper__2nlL6"};